import { FormProvider } from 'react-hook-form';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import { useCandidateAddSectionForm } from '../useCandidateAddSectionForm';
import CandidateInputForm from './CandidateInputForm';
import CandidateInputFormHeader from './CandidateInputFormHeader';
import CheckboxWithTooltip from './CheckboxWithTooltip';
import { Candidate } from '@/Models/Candidate';

const CandidateAddSection = () => {
    const { createCandidateAccountAsync } = useInviteCandidateContext();
    const form = useCandidateAddSectionForm();

    const validateApplicantAddition = async (values: Candidate): Promise<boolean> => {
        const createCandidateAccountResponse = await createCandidateAccountAsync({ ...(values as Candidate) });

        if (createCandidateAccountResponse) {
            form.setError('email', { type: 'custom', message: createCandidateAccountResponse });
            return false;
        }

        return true;
    };

    const addCandidateHandlerAsync = async (values: Candidate) => {
        if (await validateApplicantAddition(values)) {
            form.reset();
        }
    };

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(addCandidateHandlerAsync)}>
                <div className="my-2.5 flex flex-col gap-2.5">
                    <CandidateInputFormHeader />
                    <div>
                        <CandidateInputForm />
                        <CheckboxWithTooltip />
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};

export default CandidateAddSection;
